import { Accordion } from 'shared/components/Accordion/Accordion'
import { Text } from 'shared/components/Text/Text'
import { bgGray, darkGray, midGray } from 'shared/theme/colors'
import { styled } from 'styled-components'

import { formatReadableDate } from '../../../helpers/dateHelpers'
import { DeductionConfig } from '../../../models/repayments'
import { FlexBox } from '../../Base/FlexBox'
import { POLICY_DETAIL_CARD_HORIZONTAL_PADDING } from './PolicyDetailCard'
import { PolicyTableRow } from './PolicyDetailHistory'

interface PolicyActivityItemProps {
  config: DeductionConfig
  children: React.ReactNode
  cta?: React.ReactNode
}

export function PolicyActivityItem({ config, children, cta }: PolicyActivityItemProps) {
  return (
    <Accordion details={<PolicyConfigAccordionDetail>{children}</PolicyConfigAccordionDetail>}>
      {() => (
        <PolicyTableRow>
          <Text variant="label2" color={midGray}>
            {formatReadableDate(config.date_served || config.date_scheduled)}
          </Text>
          <FlexBox gap="20px" alignItems="center">
            <Text variant="header3" color={midGray}>
              {config.update_note}
            </Text>
            {cta}
          </FlexBox>
          <Text variant="header3" fontColor={darkGray}>
            {config.created_by_note}
          </Text>
        </PolicyTableRow>
      )}
    </Accordion>
  )
}

const PolicyConfigAccordionDetail = styled.div`
  background: ${bgGray};
  margin: 0 -${POLICY_DETAIL_CARD_HORIZONTAL_PADDING - 5}px 10px;
  padding: 20px ${POLICY_DETAIL_CARD_HORIZONTAL_PADDING}px;
`
